import {Api} from "./api"

export default class ProjectApi extends Api {
    constructor() {
        super("/project");
    }

    async getProject(projectID: number) {
        return await this.call("/get_project", {projectID})
    }

    async getProjects() {
        return await this.call("/list_project")
    }

    async addProject(projectName: string) {
        return await this.call("/add_project", {projectName});
    }

    async deleteProject(projectID: number) {
        return await this.call("/delete_project", {projectID});
    }

    async updateProject(projectID: number, projectName: string) {
        return await this.call("/update_project", {projectID, projectName});
    }
}